/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPrompt = createReactComponent("outline", "prompt", "IconPrompt", [["path", { "d": "M5 7l5 5l-5 5", "key": "svg-0" }], ["path", { "d": "M13 17l6 0", "key": "svg-1" }]]);

export { IconPrompt as default };
//# sourceMappingURL=IconPrompt.mjs.map
